<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/gas/getLngStation"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="platform">
          <Select v-model="searchData.platform" placeholder="渠道">
            <Option value="">全部</Option>
            <Option v-for="(item,key) in platform" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="provinceDone">
          <Select v-model="searchData.provinceDone" placeholder="省市区完整">
            <Option value="">全部</Option>
            <Option value="-1">不完整</Option>
            <Option value="1">完整</Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="注册时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="editStationPrice">对外价格修改</Button>
        </FormItem>
      </template>
    </pageTable>

    <stationEditForm v-if="showStationEdit"
               :show-edit="showStationEdit"
               :station_id="editStationId"
               ref="editModel"
               @cancel-edit="showStationEdit=false"
    >
    </stationEditForm>

    <userEditForm v-if="showUserDetail"
                     :show-edit="showUserDetail"
                     :user_id="editUserId"
                     ref="editModel"
                     @cancel-edit="showUserDetail=false"
    >
    </userEditForm>

    <Drawer title="油站详情" width="900"
            :value="showAddForm"
            :mask-closable="true" @on-close="cancelAddStation">
      <addStationForm v-if="showAddForm"></addStationForm>
    </Drawer>


    <Modal
            v-model="editProvinceForm.isShow"
            :title="editProvinceForm.title"
            :loading="editProvinceForm.isLoading"
            @on-ok="doEditProvince"
            @on-cancel="cancelEditProvince">
      <p>原省市区：{{editProvinceForm.oldAddress}}</p>
      <Form ref="rechargeForm" :label-width="100" :model="editProvinceForm">
        <Cascader :data="provinceData" v-model="editProvinceForm.province"></Cascader>
      </Form>
    </Modal>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationEditForm from "./edit";
  import userEditForm from "../user/edit";
  import addStationForm from "./addStation";
  import XLSX from 'xlsx'
  export default {
    name: "ty",
    components:{pageTable,stationEditForm,userEditForm,addStationForm},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        showStationEdit:false,
        editStationId:0,
        showAddForm:false,
        searchData: {
          gas_name: '',
          station_id:'',
          create_time:'',
          self_support:'',
          platform:'',
          provinceDone:'',
        },
        tableColumn: [
          {title: 'ID',key: 'station_id',align: "center",render:(h,params)=>{
                return h('div',[
                  h('span',params.row.station_id),
                  h('Tag',{props:{color:'orange'}},params.row.platform),
                ])
            }},
          {title: '油站名称',key: 'gas_name',align: "left"},
          {title: '省市区',align: "left",render:(h,params)=>{
            return h('div',{
              on:{
                click:()=>{
                  this.editProvince(params.row)
                }
              }
            },`${params.row.province_name}/${params.row.city_name}/${params.row.county_name}`)
            }},
          {title: '剩余升数(L)',key: 'litre_balance',align: "center"},
          {title: '开通库存',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_open_stock === 1,
                },
                scopedSlots:{
                  open:()=>h('span','开启'),
                  close:()=>h('span','关闭')
                },
                on:{
                  'on-change':(e)=>{
                    console.log(e)
                    this.setOpenStock(params.row,e)
                  }
                }
              })
            }},
          /*{title: '联系方式',key:'contact_user',align: "center",width:140,render:(h,params)=>{
              return h('div',[
                h('p',params.row.contact_user),
                h('p',params.row.contact_mobile),
              ])
            }},*/
          {title: '对外价格',key: 'price',align: "center",render:(h,params)=>{
              return h('div',params.row.price)
           /* if (params.row.station_price===params.row.price){
              return h('div',params.row.station_price)
            }else{
              return h('div',[
                h('div',params.row.station_price),
                h('div',{style:{color:'red'}},params.row.price),
              ])
            }*/
            }},
          {title: '对内价格',key: 'price2',align: "center",},
          {title: '是否带票',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_bill === 1,
                },
                scopedSlots:{
                  open:()=>h('span','带票'),
                  close:()=>h('span','不带')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsBill(params.row,e)
                  }
                }
              })
            }},
          {title: '是否可提现',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_withdraw === 1,
                },
                scopedSlots:{
                  open:()=>h('span','可以'),
                  close:()=>h('span','不能')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsWithdraw(params.row,e)
                  }
                }
              })
            }},
          {title: '是否壳牌支付',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_need_qppay === 1,
                },
                scopedSlots:{
                  open:()=>h('span','是的'),
                  close:()=>h('span','不是')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsNeedQppay(params.row,e)
                  }
                }
              })
            }},
          {title: '待结算',key: 'unsettle_amount',align: "center",},
          // {title: '注册时间',key:'create_time',align: "center"},
          {title: '状态',align: "center",render:(h,params)=>{
            let status = parseInt(params.row.gas_status)
              if (status === 1){
                return h('span','正常')
              }else if(status === 5){
                return h('span',{style:{color:'blue'}},'待审核')
              }else{
                return h('span',{style:{color:'red'}},'禁用')
              }
            }},
          {title: '操作',width:140,render:(h,params)=>{
            return h('div',[
              h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showDetail(params.row.station_id)}}},'查看'),
              h('Button',
                {props:{type:'error',size:'small'},
                  style:{marginLeft:'5px'},
                on:{click:()=>{this.del(params.row)}}
                },
                '删除'),
            ])
            }},
        ],
        tableData: [],
        stationChangePrice:'',
        platform:[{id:'自营',name:'自营'}],
        editProvinceForm:{
          isShow:false,
          isLoading:false,
          title:'',
          station_id:0,
          oldAddress:'',
          province:[]
        },
        provinceData:[]
      }
    },
    methods: {
      editSuccess(){
        this.showAddForm = false;
        this.$refs.table.getLists();
      },
      showDetail(station_id){
        this.showStationEdit = true
        this.editStationId = station_id
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      showAddStation(){
        this.showAddForm = true
      },
      cancelAddStation(){
        this.showAddForm = false;
      },
      async initPage(){
        let res = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['platform']});
        this.platform = res.data.platform
        let res2 = await this.$commonFun.postProxy('admin/gas/getAllProvinceData',{});
        this.provinceData = res2.data
      },
      async del(info){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除站点:${info.gas_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/delStation',{station_id:info.station_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async setOpenStock(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setOpenStock',{station_id:info.station_id,isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
            this.$refs.table.getLists();
          }
        })
      },
      async setIsBill(info,isOpen){
        this.$set(info,'is_bill',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsBill',{station_id:info.station_id,is_bill:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_bill',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async setIsWithdraw(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_withdraw',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsWithdraw',{station_id:info.station_id,is_withdraw:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_withdraw',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async setIsNeedQppay(info,isOpen){
        this.$set(info,'is_need_qppay',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsNeedQppay',{station_id:info.station_id,is_need_qppay:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_need_qppay',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async editStationPrice(){
        this.$Modal.confirm({
          render:(h)=>{
            return h( 'Input', {
              props:{value:this.stationChangePrice,size:'large',autofocus: true,type: 'number',},
              on:{
                input:(val)=>{
                  this.stationChangePrice = val;
                }
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let params = this.searchData;
            params.price = this.stationChangePrice
            let res = await this.$commonFun.postProxy('admin/gas/editStationPriceByMap',params);
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            // this.$Modal.remove()
          }
        })
      },
      editProvince(info){
        this.editProvinceForm.isShow = true
        this.editProvinceForm.station_id = info.station_id
        this.editProvinceForm.title = info.gas_name
        this.editProvinceForm.oldAddress = `${info.province_name} / ${info.city_name} / ${info.county_name}`
        this.editProvinceForm.province = [info.province_code+'',info.city_code+'',info.county_code+'']
        console.log(this.editProvinceForm.province)
      },
      cancelEditProvince(){
        this.editProvinceForm.isShow = false
        this.editProvinceForm.station_id = 0
        this.editProvinceForm.title = ''
        this.editProvinceForm.oldAddress = ''
        this.editProvinceForm.province = []
      },
      async doEditProvince(){
        let params = {
          station_id:this.editProvinceForm.station_id,
          province:this.editProvinceForm.province,
        }
        let res = await this.$commonFun.postProxy('admin/gas/editProvince',params);
        this.cancelEditProvince()
        this.$commonFun.dealApiResult(res)
      }
    },
    mounted() {
      this.initPage()
    },
  }
</script>

<style scoped>

</style>
